<!--
 * @Author: andy_chen
 * @created: 2018-10-23 15:57:46
-->

<template>
    <div class="container" v-if="!isWechatAuth">
        <svg-icon class="wechat-icon" icon-class="wechat"/>
        <p class="wechat-login-tip">使用微信登录后，才可以浏览结伴信息</p>
        <a :href="wechatAuthUrl" class="cat-btn small round">一键登录</a>
    </div>
</template>

<script>
import { getWechatAuthUrl } from "../utils/weixin.js";
export default {
    name: "WechatLogin",
    data() {
        return {
            wechatAuthUrl: "javascript:;",
            isWechatAuth: false
        };
    },
    mounted() {
        console.log("login mounted");
        let query = this.$route.query;
        if (query.code) {
            this.isWechatAuth = true;
            // 已经授权成功的情况，从微信那里拿到 code 了
            let code = query.code;
            // console.log(`get code ---> ${code}`);
            this.$loading.open({ text: "登录中..." });
            this.$store
                .dispatch("LoginByWechat", code)
                .then(res => {
                    this.$loading.close();
                    this.isWechatAuth = false;
                    if (+res.code === 200) {
                        let redirect = this.$route.query.redirect;
                        let path = redirect
                            ? decodeURIComponent(redirect)
                            : "/";
                        this.$router.push({ path: path });
                    } else {
                        this.$messageBox({ type: "alert", title: res.msg });
                        this.resetWechatAuthUrl();
                    }
                })
                .catch(error => {
                    this.isWechatAuth = false;
                    console.error(error);
                    this.$loading.close();
                });
        } else {
            // console.log(`no code`);
            this.resetWechatAuthUrl();
        }
    },
    methods: {
        resetWechatAuthUrl() {
            let redirectUrl = window.location.href;
            this.wechatAuthUrl = getWechatAuthUrl(redirectUrl);
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

.container {
    background: $baseBackgroundColor;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.61rem;
}

.wechat-icon {
    font-size: 2rem;
}

.wechat-login-tip {
    font-size: 0.28rem;
    margin-top: 0.32rem;
    margin-bottom: 0.32rem;
}

.cat-btn {
    width: 2.43rem;
}
</style>
